// frontend/src/components/AnalyticsPage.js
import React from 'react';

function AnalyticsPage() {
  return (
    <div className="p-6">
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 dark:bg-gray-800 dark:border dark:border-gray-700">
        <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">Advanced Analytics</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Explore and analyze your FAST TV data with powerful interactive tools.
        </p>
        
        {/* Coming Soon Banner */}
        <div className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded-md dark:bg-purple-900/30">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-purple-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-purple-800 dark:text-purple-300">Coming Soon</h3>
              <div className="mt-2 text-sm text-purple-700 dark:text-purple-400">
                <p>Advanced analytics features are currently in development. Stay tuned for powerful data exploration tools!</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Placeholder Analysis Tools */}
        <div className="mt-8">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-4">Analysis Tools</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Data Explorer Tool */}
            <div className="bg-gray-50 p-5 rounded-lg border border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <h4 className="text-lg font-medium text-gray-800 dark:text-gray-200">Data Explorer</h4>
              </div>
              <p className="text-gray-600 dark:text-gray-400 mb-4">Build custom queries with an intuitive drag-and-drop interface. Explore relationships between different metrics and dimensions.</p>
              <div className="bg-white p-4 rounded-md border border-gray-200 opacity-50 dark:bg-gray-700 dark:border-gray-600">
                <div className="flex justify-between mb-2">
                  <div className="h-6 w-24 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 w-16 bg-gray-200 rounded dark:bg-gray-600"></div>
                </div>
                <div className="h-32 bg-gray-200 rounded-md dark:bg-gray-600"></div>
              </div>
              <button className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 opacity-50 cursor-not-allowed dark:bg-indigo-700">
                Coming Soon
              </button>
            </div>
            
            {/* Cohort Analysis */}
            <div className="bg-gray-50 p-5 rounded-lg border border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
                <h4 className="text-lg font-medium text-gray-800 dark:text-gray-200">Cohort Analysis</h4>
              </div>
              <p className="text-gray-600 dark:text-gray-400 mb-4">Track how different viewer segments behave over time. Identify trends in retention and engagement.</p>
              <div className="bg-white p-4 rounded-md border border-gray-200 opacity-50 dark:bg-gray-700 dark:border-gray-600">
                <div className="grid grid-cols-6 gap-1 mb-2">
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-gray-600"></div>
                </div>
                <div className="h-32 bg-gray-200 rounded-md dark:bg-gray-600"></div>
              </div>
              <button className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 opacity-50 cursor-not-allowed dark:bg-green-700">
                Coming Soon
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Predictive Analytics */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <h4 className="font-medium text-gray-800 dark:text-gray-200">Predictive Analytics</h4>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">AI-powered forecasting of viewership trends and audience behavior.</p>
              <button className="mt-3 text-sm text-purple-600 hover:text-purple-800 dark:text-purple-400 dark:hover:text-purple-300 opacity-50 cursor-not-allowed">
                Coming Soon
              </button>
            </div>
            
            {/* Cross-Platform Analysis */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
                <h4 className="font-medium text-gray-800 dark:text-gray-200">Cross-Platform Analysis</h4>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Compare performance metrics across different streaming platforms.</p>
              <button className="mt-3 text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 opacity-50 cursor-not-allowed">
                Coming Soon
              </button>
            </div>
            
            {/* Custom Segments */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
                <h4 className="font-medium text-gray-800 dark:text-gray-200">Custom Segments</h4>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Create and save custom audience segments for targeted analysis.</p>
              <button className="mt-3 text-sm text-amber-600 hover:text-amber-800 dark:text-amber-400 dark:hover:text-amber-300 opacity-50 cursor-not-allowed">
                Coming Soon
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnalyticsPage;
